import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  firebaseUrl = environment.firebaseUrl;

  constructor(private angularFirestore: AngularFirestore, private http: HttpClient) { }

  getPointsConfig(): Observable<any> {
    return this.angularFirestore.doc('generalSettings/pointsConfig')
      .snapshotChanges()
      .pipe(map(snaps => {
        return {
          id: snaps.payload.id,
          data: snaps.payload.data()
        };
      }), first());
  }


  // getPointsRegisterHistoryByUser(userId: string, daysFromNow: number): Observable<any[]> {
  getPointsRegisterHistoryByUser(userId: string, daysFromNow: number, token: string): Observable<any> {
    const dateToQuery = new Date();
    console.log('today:', dateToQuery);

    dateToQuery.setDate((dateToQuery.getDate() - daysFromNow));

    console.log('fecha anterior: ', dateToQuery);

    const headers = new HttpHeaders({
      authorization: 'Bearer ' + token
    });

    return this.http.get<string>(this.firebaseUrl + 'getPointsRegisterHistoryByUser?userId=' + userId, {
      headers
    });
    //Mejhor realizar funcion de firebase para traer estos datos pues el reljo del usuario puede estar chueco o pueden alterarlo

    // const formatedData =

    // firebase.firestore.FieldValue.serverTimestamp()



  }

}
